import { render, staticRenderFns } from "./ModulesShow.vue?vue&type=template&id=84d5e030&scoped=true"
import script from "./ModulesShow.vue?vue&type=script&lang=js"
export * from "./ModulesShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d5e030",
  null
  
)

export default component.exports